import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as EventsUtils from '../../../../utils/events'

import PlaceHolder from '../../../atoms/PlaceHolder'
import { Col, Row } from '../../../atoms/Grid'
import Font from '../../../atoms/Font'
import Loading from '../../../atoms/Loading'
import Button from '../../../atoms/Button'
import ServiceBox, { ModalService } from '../../../molecules/ServiceBox2'
import Alert from '../../../atoms/Alert'
import { numberFormat } from '../../../../libraries/Formatter'
import T from '../../../../SPRINTA/translate/T'
import { openModal } from '../../../../modules/actions/Modais'

import CompleteRegistration from '../../../container/CompleteRegistration'

class PageExtras extends Component {

    state = {
        loading: true,
        data: [],
        values: [],
        optionsValue: [],
        error: '',
        loading_btn: false,
        CompleteRegistration: false,
        isCompleted: false,
        productData: null
    }

    componentWillMount() {
        EventsUtils.loadExtras(this.props.token, 1)
        .then(resp => {
            this.setState({
                loading: false,
                data: resp
            })
        })
    }

    handleChangeExtrasOption(target) {
        let optionsValue = this.state.optionsValue
        optionsValue[target.name] = target.value
        this.setState({
            ...this.state,
            optionsValue
        })
    }

    handleChangeExtras(target) {
        let values = this.state.values
        values[target.name] = target.value
        this.setState({
            ...this.state,
            values
        })
    }

    validExtras() {
        let extras = this.state.data
        let values = this.state.values
        let options = this.state.optionsValue

        if(values.length === 0) {
            this.setState({
                ...this.state,
                error: T.txt('fill_buy_extras_page')
            })
            return
        }

        for (var i = 0; i < extras.length; i++) {
            let extra = extras[i]
            let value = parseInt(values[parseInt(extra.id, 10)], 10) || 0
            let option = options[parseInt(extra.id, 10)] || ''

            if(extra.options !== "" && option === "" && value !== 0) {
                this.setState({
                    error: T.text('field_extra_mandatory', { extra_name: extra.description, field: extra.options_label})
                })
                return false
            }
        }

        return true
    }

    componentWillReceiveProps(nextProps) {
        if(!this.state.loading_btn) return


        if(nextProps.login.isLogged !== this.props.login.isLogged) {
            this.props = nextProps
            this.handleSubmit()
        }
    }

    componentWillUpdate(np, ns) {
        if(!this.state.loading_btn) return true

        if(ns.isCompleted && !this.state.isCompleted) {
            this.setState({
                ...ns
            }, () => {
                this.handleSubmit()
            })
        }


        return true
    }

    handleSubmit() {
        if(!this.validExtras()) return

        if(!this.props.login.isLogged) {
            this.props.openModal('modal-login')
            return
        }

        this.setState({
            error: '',
            loading_btn: true
        })

        if(!this.state.isCompleted && !this.state.CompleteRegistration) {
            this.setState({
                CompleteRegistration: true
            })
            return
        }

        let form = {}
        let extras = this.state.values
        if(extras) {
            Object.keys(extras).forEach(function(item) {
                form[`extras[${item}]`] = extras[item]
            }, this)
        }

        let extras_options = this.state.optionsValue
        if(extras_options) {
            Object.keys(extras).forEach(function(item) {
                form[`extras_options[${item}]`] = extras_options[item]
            }, this)
        }

        EventsUtils.checkoutExtras(form, this.props.token)
        .then(resp => {
            if(resp.errors)
                this.setState({
                    error: resp.errors[0].message,
                    loading_btn: false
                })

            if(resp.redirect_to)
                window.location = resp.redirect_to
        })

    }

    render() {
        return (
            <div style={{padding: '40px 0'}}>
                <CompleteRegistration
                    active={this.state.CompleteRegistration}
                    handleOpened={() => {
                    }}
                    handleDone={() => {
                        this.setState({
                            isCompleted: true,
                        })
                    }}
                />

                <Col size={12}>
                    <Font size='30' color='#4a4a4a' weight='100'>{T.text('items_extras')}</Font>
                </Col>

                <div style={{paddingTop: '20px', float: 'left', width: '100%'}}>
                    { this.state.loading ? (
                        <div>
                            <Col size={6}>
                                <PlaceHolder type='retangle' style={{ height: '300px'}} />
                            </Col>
                            <Col size={6}>
                                <PlaceHolder type='retangle' style={{ height: '300px'}} />
                            </Col>
                        </div>
                    ) : (
                        <span>
                            <div style={{ display: 'flex', alignItems: 'stretch', flexWrap: 'wrap'}}>
                            {this.state.data.map(item => (
                                <Col size={6} key={item.id} style={{marginBottom: '30px'}} float={this.state.data.length === 1 ? 'center' : ''}>
                                    <ServiceBox
                                        name={`${item.id}`}
                                        value={this.state.values[`${item.id}`] || ''}
                                        onChange={(e) => {
                                            this.handleChangeExtras(e.target)
                                        }}
                                        mandatory={item.is_mandatory}
                                        options={item.options}
                                        options_label={item.options_label}
                                        image={item.image !== '' ? `${window.config.url_event_extras_images}${item.image}` : ''}
                                        limit={item.quantity_limit || 10}
                                        option_value={this.state.optionsValue[`${item.id}`] || ''}
                                        onChangeOption={(e) => {
                                            this.handleChangeExtrasOption(e.target)
                                        }}
                                        title={item.description}
                                        description={item.long_description}
                                        price={item.price > 0 ? `R$ ${numberFormat(item.price,2,',','.')}` : T.txt('free')}
                                        handleModal={data => this.setState({
                                            productData: data
                                        })}/>
                                </Col>
                            ))}
                            </div>
                            <div>
                                <Col size={12} style={{padding: '20px', textAlign: "right"}}>
                                    <Row>
                                        { this.state.error !== '' && (

                                            <div style={{ padding: '0 5px', textAlign: 'left'}}>
                                                <Alert type="danger">{this.state.error}</Alert>
                                            </div>
                                        )}
                                    </Row>
                                    <Row>
                                        <Button color="orange" onClick={() => {
                                            this.handleSubmit()
                                        }} inline>
                                    {this.state.loading_btn
                                    ? <Loading color="#fff" />
                                    : T.text('buy_items')}
                                        </Button>
                                    </Row>
                                </Col>
                            </div>
                        </span>
                    )}

                </div>
                <ModalService
                      active={this.state.productData ? true : false}
                      data={this.state.productData}
                      handleClose={() => this.setState({
                          productData: null
                      })}/>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    login: state.login
})
const mapDispatchToProps = dispatch => bindActionCreators({
    openModal
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(PageExtras)



// WEBPACK FOOTER //
// ./src/components/templates/Event/PageExtras/index.js